import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  StonegroupsList,
  StonesList,
  ShapesList,
  CutsList,
  ClaritysList,
  StonecolorsList,
  CertificateTypelist,
  StoneVarientType,
} from "./masters";

const handleKeyPress = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
  }
};

/**
 * One left-column stone block. Memoized so editing another stone does not re-render this row.
 */
const ProductAdvancedStoneRow = ({
  element,
  index,
  stoneCount,
  isLast,
  varientType,
  set_stoneGroup,
  setFormValues_stone,
  setShape_ids,
  setDesignValue,
  setAdvanceProductData,
  onFieldChange,
  onAdd,
  onRemove,
  base_assets,
}) => {
  const { t } = useTranslation();

  return (
    <div className="product-com-box-layout">
      <div className="row product-ct-wrap-col-left-input-select-wrap mb-5">
        <h4 className="pro-sub-heading" id={"dataStone_" + index}>
          {t("Stone")}
          {stoneCount > 1 ? (
            <span className="pro-sub-heading-serial">{" #" + (index + 1)}</span>
          ) : (
            ""
          )}
        </h4>
        <div className="col-xl-7 col-md-12">
          <div className="row gx-2 mb-4 bg-box-input">
            <div className="col-md-4">
              <div className="placeholder-up-input w-100">
                <StonegroupsList
                  index_stone={index}
                  selected_id={element.StoneGroup ? element.StoneGroup : ""}
                  setFormValues_stone={setFormValues_stone}
                  set_stoneGroup={set_stoneGroup}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="placeholder-up-input w-100">
                <StonesList
                  index_stone={index}
                  selected_id={element.Stone ? element.Stone : ""}
                  selectedStone_id={
                    element.StoneGroup ? element.StoneGroup : ""
                  }
                  setFormValues_stone={setFormValues_stone}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div
                className={
                  "placeholder-up-input w-100 " +
                  (varientType === 1 || varientType === 2 ? "yellow-input" : "")
                }
              >
                <StoneVarientType
                  index_stone={index}
                  selected_id={element.StoneVariant}
                  setFormValues_stone={setFormValues_stone}
                  setDesignValue={setDesignValue}
                  setAdvanceProductData={setAdvanceProductData}
                />
              </div>
            </div>
          </div>
          <div className="row gx-2">
            <div className="col-md-3">
              <div className="placeholder-up-input w-100">
                <ShapesList
                  index_stone={index}
                  selected_id={
                    element.StoneShape ? element.StoneShape : "value"
                  }
                  setShape_ids={setShape_ids}
                  setFormValues_stone={setFormValues_stone}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="placeholder-up-input w-100">
                <CutsList
                  setFormValues_stone={setFormValues_stone}
                  index_stone={index}
                  selected_id={element.StoneCut ? element.StoneCut : "value"}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="placeholder-up-input w-100">
                <ClaritysList
                  setFormValues_stone={setFormValues_stone}
                  index_stone={index}
                  selected_id={
                    element.StoneClarity ? element.StoneClarity : ""
                  }
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="placeholder-up-input w-100">
                <StonecolorsList
                  setFormValues_stone={setFormValues_stone}
                  index_stone={index}
                  selected_id={element.StoneColor ? element.StoneColor : ""}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="product-ct-wrap-col-left-ecommerce-cat-box product-ct-wrap-col-left-additional-info-box">
        <h4 className="product-ct-wrap-col-left-additional-info-box-heading">
          {t("Additional Information")}
          <span className="question-mark">{t("?")}</span>
        </h4>
        <div className="row">
          <div className="col-md-7">
            <div className="row gx-2">
              <div className="col-md-4">
                <div className="placeholder-up-input w-100">
                  <CertificateTypelist
                    setFormValues_stone={setFormValues_stone}
                    selected_id={
                      element.Certificatetype
                        ? element.Certificatetype
                        : "value"
                    }
                    index_stone={index}
                  />
                </div>
              </div>
              <div className="col-md-8">
                <div className="placeholder-up-input form-floating w-100">
                  <input
                    id={`certificateNo_${index}`}
                    onBlur={(e) =>
                      onFieldChange(e.target.value, index, "certificateNo")
                    }
                    className="placeholder-up-input-field"
                    defaultValue={element.certificateNo}
                    placeholder=""
                    onKeyPress={handleKeyPress}
                  />
                  <label className="placeholder-up-input-label">
                    {t("Certificate No.")}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 d-flex gap-2">
            {isLast ? (
              <>
                {stoneCount > 1 ? (
                  <button
                    type="button"
                    onClick={() => onRemove(index)}
                    className="add-more-pro danger-text ct-disable-btn"
                  >
                    <img
                      src={base_assets + "images/icons/minus-detail.png"}
                      alt=""
                    />
                    {t("Remove")}
                  </button>
                ) : (
                  ""
                )}
                <button
                  type="button"
                  onClick={onAdd}
                  className="add-more-pro ct-disable-btn"
                >
                  <img
                    src={base_assets + "images/icons/add-detail.png"}
                    alt=""
                  />
                  {t("Add more stones")}
                </button>
              </>
            ) : (
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="add-more-pro danger-text ct-disable-btn"
              >
                <img
                  src={base_assets + "images/icons/minus-detail.png"}
                  alt=""
                />
                {t("Remove")}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ProductAdvancedStoneRow);
